import {Centre} from "../styled/Center.styled";

function SignUp(props) {
    return <Centre>
    <h1>Sign Up</h1>
    <p>To be added soon!!!</p>
</Centre>;
}

export default SignUp;